import React from 'react';
// import PropTypes from 'prop-types';
import styled from 'styled-components';

import responsiveValues from 'utils/ResponsiveValues';

import Circle from './Circle';
import Wrapper from './Wrapper';

const LoadingIndicatorContainer = styled.div`
  position: fixed;
  top: 10%;
  left: calc(50% + 200px);
  transform: translate(-50%, -50%);
  z-index: 999;

  @media(max-width: ${responsiveValues.sidebarMedium}px) {
    left: calc(50% + 150px);
  }

  @media(max-width: ${responsiveValues.sidebarNone}px) {
    left: 50%;
  }
`;

const LoadingIndicator = () => (
  <LoadingIndicatorContainer>
    <Wrapper>
      <Circle />
      <Circle rotate={30} delay={-1.1} />
      <Circle rotate={60} delay={-1} />
      <Circle rotate={90} delay={-0.9} />
      <Circle rotate={120} delay={-0.8} />
      <Circle rotate={150} delay={-0.7} />
      <Circle rotate={180} delay={-0.6} />
      <Circle rotate={210} delay={-0.5} />
      <Circle rotate={240} delay={-0.4} />
      <Circle rotate={270} delay={-0.3} />
      <Circle rotate={300} delay={-0.2} />
      <Circle rotate={330} delay={-0.1} />
    </Wrapper>
  </LoadingIndicatorContainer>
);

LoadingIndicator.propTypes = {

};

export default LoadingIndicator;
